module.exports = {
  draftsList: 'List of Deactivations',
  closedList: 'Closed List',
  editImage: {
    title: 'Edit Image',
  },
  header: {
    title: 'Tour Stories',
    buttonCreate: 'Create',
    buttonPublish: 'Publish',
  },
  table: {
    title: {
      index: '#',
      type: 'TYPE',
      source: 'SOURCE',
      action: 'ACTION',
      views: 'VIEWS',
    },
    tooltip: {
      edit: 'Edit',
      delete: 'Delete',
      inactive: 'InActive',
      active: 'Active',
      schedule: 'Schedule',
    },
    popup: {
      title: 'Confirm',
      okBtn: 'Yes',
      cancelBtn: 'No',
      delete: 'Are you sure you want to delete this Tour Story?',
      deleteMultiple: 'Are you sure you want to delete the selected Tour Stories?',
      edit: 'Are you sure to edit this Tour Story?',
      enable: 'Are you sure you want to enable this Tour Story?',
      disable: 'Are you sure you want to disable this Tour Story?',
      confirmPassword: 'Please input your password to confirm.',
    },
  },
  form: {
    image3x4: 'Please upload an image',
    imageUpload: '* Upload an image',
    assetImage: 'Asset',
    countries: 'Countries',
    btnUpdateTourStory: 'Update',
    btnCreateTourStory: 'Add',
    done: 'Done',
    scheduleTile: 'Schedule Tour Story',
    updateTourStory: 'Edit Tour Story',
    createTourStory: 'Add Tour Story',
    titleColor: 'Asset',
    btnSubmit: 'Submit',
  },
  validate: {
    countryBlank: 'Please select country!',
    imageBlank: 'Please input an image!',
  },
  tab: {
    detail: {
      form: {
        time: {
          title: 'Time',
          startTimePlaceholder: 'Start time',
          endTimePlaceholder: 'End time',
          startDatePlaceholder: 'Start date',
          endDatePlaceholder: 'End date',
        },
        validate: {
          titleBlank: 'Please input title.',
          countryBlank: 'Please select Country',
          descriptionBlank: 'Please input description.',
          startBeforeNow: 'The start date time must be after now.',
          endBeforeNow: 'The end date time must be after now.',
          startBeforeEnd: 'The start date must be before the end date time.',
          startTimeBlank: 'Please input start time.',
          endTimeBlank: 'Please input end time.',
          startDateBlank: 'Please input start date.',
          endDateBlank: 'Please input end date.',
          productNameBlank: 'Please input product name.',
          productDescriptionBlank: 'Please input product description.',
          productVideoTypeBlank: 'Please input product video type.',
          productVideoIdBlank: 'Please input product video id.',
          frequencyBlank: 'Please input push notifications reminder frequency.',
        },
      },
    },
  },
  message: {
    error: {
      uploadImage: 'There was an error while uploading the image. Please try again',
      requireUpload: 'Please upload an image.',
      maxItem: 'Please disable another tile before enabling a new one.',
      createTourStory: 'Tour Story upload error.',
      selectedDelete: 'Please select at least 1 Tour Story to delete.',
    },
    success: {
      updateTourStory: 'Tour Story successfully updated.',
      createTourStory: 'Tour Story successfully added.',
      scheduleTile: 'Tour Story successfully scheduled.',
      deleteTourStory: 'Tour Story successfully deleted.',
      deleteMultipleTourStory: 'Tour Stories successfully deleted.',
    },
  },
};
